<template lang="html">
  <div>
    <Layout :currentMenu="currentMenu" :subMenu="subMenu" :fullScreenLoading="saving">
      <LoadingSection :loading="loading" :title="subMenu" :autoPadding="false">
        <template v-slot:content>
          <SymbiumButton
            :text="`New ${subMenu}`"
            :onClick="openNewOwnershipModal"
            :isSmall="true"
          />
          <div v-for="ownership in ownerships" :key="ownership.id">
            <BuildPlusTemplate
              :ownership="ownership"
              v-if="isBuildPlus"
              @update="(event) => updateOwnership(ownership, event.attribute, event.value)"
              @save="() => askToSave(ownership)"
              @destroy="() => askToDestroy(ownership)"
            />
            <BuildPlusTemplate
              :ownership="ownership"
              v-if="isPlancheck"
              @update="(event) => updateOwnership(ownership, event.attribute, event.value)"
              @save="() => askToSave(ownership)"
              @destroy="() => askToDestroy(ownership)"
              />
          </div>
          <div v-if="paginateData.page_count > 1">
            <div class="gap-3x" />
            <PaginationContainer
              :paginateData="paginateData"
              @page-change="reloadOwnerships"
              klass="section-field"
            />
          </div>
        </template>
      </LoadingSection>
    </Layout>
    <NewOwnershipModal @created="() => reloadOwnerships(1)" />
    <ConfirmModal />
  </div>
</template>

<script>
import _ from 'lodash'

import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import Layout from 'src/components/dashboard/shares/Layout.vue'
import LoadingSection from 'src/components/dashboard/shares/LoadingSection.vue'
import ConfirmModal from "src/components/common/modals/ConfirmModal.vue";
import PaginationContainer from 'src/components/common/utility/PaginationContainer.vue'

import BuildPlusTemplate from './BuildPlusTemplate.vue'
import NewOwnershipModal from './NewOwnershipModal.vue'

export default {
  components: {
    SymbiumButton, Layout, LoadingSection, NewOwnershipModal,
    BuildPlusTemplate, ConfirmModal, PaginationContainer
  },
  props: ['type', 'currentMenu'],
  data() {
    return {
      ownerships: [],
      loading: false,
      saving: false,
      ownershipType: this.type,
      paginateData: { page: 1 },
    }
  },
  methods: {
    assignData(response) {
      this.loading = false
      this.ownerships = response.data.ownerships
      this.paginateData = _.pick(response.data, [
        "page_count",
        "per_page",
        "last_page",
        "first_page",
        "total_count",
        "page",
      ])
    },
    openNewOwnershipModal() {
      this.$modal.show('new-ownership-modal', {
        type: this.ownershipType
      })
    },
    askToSave(ownership) {
      this.$modal.show('confirm-modal', {
        actionText: 'Continue',
        confirmMessage: 'Are you sure to save this subscription changes?',
        confirmCallBack: () => this.save(ownership),
        alert: false,
      })
    },
    askToDestroy(ownership) {
      this.$modal.show('confirm-modal', {
        actionText: 'Destroy',
        confirmMessage: 'Are you sure to destroy this subscription?',
        confirmCallBack: () => this.destroy(ownership),
      })
    },
    save(ownership) {
      if(this.saving) return;
      this.$modal.hide('confirm-modal')
      this.saving = true;
      this.$ownership.update(ownership, this.afterSave, this.afterSaveError)
    },
    destroy(ownership) {
      if(this.saving) return;
      this.$modal.hide('confirm-modal')
      this.saving = true;
      this.$ownership.destroy(ownership, () => {
        this.saving = false
        this.reloadOwnerships(this.paginateData.page)
      }, this.afterSaveError)
    },
    afterSave() {
      this.saving = false;
    },
    afterSaveError() {
      this.saving = false;
      alert('Something went wrong! Cannot save data now.')
    },
    updateOwnership(ownership, attribute, value) {
      ownership[attribute] = value;
    },
    reloadOwnerships(page) {
      this.loading = true;
      this.$ownership.fetch({ page, type: this.ownershipType }, this.assignData)
    }
  },
  computed: {
    isBuildPlus() {
      return this.ownershipType == 'Symbium Build+'
    },
    isPlancheck() {
      return this.ownershipType == 'Symbium Plancheck'
    },
    subMenu() {
      return this.isPlancheck ? 'Plancheck Subscriptions' : 'Build+ Subscriptions'
    },
  },
  mounted() {
    this.loading = true;
    this.$user.fetchMe();
    this.$ownership.fetch({ page: 1, type: this.ownershipType }, this.assignData)
  },
}
</script>

<style lang="scss">
.ownerships-list {
  .ownerships-list-group {
    padding: 24px;

    input {
      width: 100%;
    }

    .label {
      margin-bottom: 8px;
    }

    .form-group {
      margin-bottom: 0;
    }

    .ownerships-list-field {
      margin-left: 48px;
    }

    div {
      flex: 1;
    }
  }
}

@media screen and (max-width: 768px) {
  .ownerships-list {
    .ownerships-list-group {
      display: block;

      .ownerships-list-field {
        margin: 0;
      }
    }
  }
}
</style>
